import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { MAP_CONTAINER_ID } from 'shared/constants/map';

import * as styles from './InfrastructureWrapper.css';

export interface IInfrastructureWrapperProps {
  headerLinks: React.ReactNode;
  /**
   * будет ли контейнер ли обернут в <CardSectionNew/>
   */
  wrapped?: boolean;
}

export const InfrastructureWrapper: React.FC<React.PropsWithChildren<IInfrastructureWrapperProps>> = ({
  headerLinks,
  wrapped,
  children,
}) => {
  const content = (
    <section className={styles['wrapper']} id={MAP_CONTAINER_ID}>
      <div className={styles['header']}>
        <UIHeading1 as="h1" fontWeight="bold">
          Расположение
        </UIHeading1>
        <div className={styles['links']}>{headerLinks}</div>
      </div>
      {children}
    </section>
  );

  return wrapped ? <CardSectionNew>{content}</CardSectionNew> : content;
};
